import { TypeSelectOption } from '@thefarmersfront/kitchen';

/**
 * 재고관리에서 사용되는 페이지네이션 값들
 */
export const INITIAL_STOCK_PAGE_SIZE = 100;
export const INITIAL_STOCK_PAGE_OFFSET = 0;

export const STOCK_PAGE_SIZE = {
  100: {
    value: 100,
    text: '100개',
  },
  200: {
    value: 200,
    text: '200개',
  },
  300: {
    value: 300,
    text: '300개',
  },
} as const;

export type TypeStockPageSize = keyof typeof STOCK_PAGE_SIZE;

/**
 * [재고관리] 공통 코드
 */
export const STOCK_CODES = {
  /** 반출 출발지 센터 */
  vendorReleaseCluster: 'VENDOR_RELEASE_CLUSTER',
  /** 보관 유형 */
  temperatureType: 'TEMPERATURE_TYPE',
  /** 반출 검색어 유형 */
  vendorReleaseKeyword: 'VENDOR_RELEASE_KEYWORD',
  /** 반출 상태 */
  vendorReleaseStatus: 'VENDOR_RELEASE_STATUS',
  /** 반출 방식 */
  vendorReleaseMethod: 'VENDOR_RELEASE_METHOD',
  /** 파렛트 종류 */
  vendorReleasePalletType: 'VENDOR_RELEASE_PALLET_TYPE',
  /** 반출 패킹 방식 */
  vendorReleasePackingMethod: 'VENDOR_RELEASE_PACKING_METHOD',
  /** 반출 재고 조회 검색어 유형 */
  vendorReleaseInventoryKeyword: 'VENDOR_RELEASE_INVENTORY_KEYWORD',
} as const;

export const STOCK_CODE_KEY = {
  VENDOR_RELEASE_CLUSTER: 'vendorReleaseCluster',
  TEMPERATURE_TYPE: 'temperatureType',
  VENDOR_RELEASE_KEYWORD: 'vendorReleaseKeyword',
  VENDOR_RELEASE_STATUS: 'vendorReleaseStatus',
  VENDOR_RELEASE_METHOD: 'vendorReleaseMethod',
  VENDOR_RELEASE_PALLET_TYPE: 'vendorReleasePalletType',
  VENDOR_RELEASE_PACKING_METHOD: 'vendorReleasePackingMethod',
  VENDOR_RELEASE_INVENTORY_KEYWORD: 'vendorReleaseInventoryKeyword',
} as const;

export type TypeStockOptionCodes = keyof typeof STOCK_CODE_KEY;
export type TypeStockOptions = Partial<Record<keyof typeof STOCK_CODES, TypeSelectOption<string>[]>>;

/**
 * [재고관리] 키워드 타입별 검색 필터 키
 */
export const STOCK_KEYWORD_TYPE_FILTER_KEY = {
  SKU_CODE: 'skuCode',
  SKU_NAME: 'skuName',
  ALTER_CODE: 'barcode',
  ID: 'id',
} as const;

/**
 * [재고관리 > 반출 요청 관리] 반출 상태
 */
export const STOCK_RELEASE_REQUEST_STATUS = {
  REQUEST: {
    text: '요청',
    value: 'REQUEST',
    color: 'secondary',
  },
  PROGRESS: {
    text: '진행',
    value: 'PROGRESS',
    color: 'info',
  },
  COMPLETE: {
    text: '완료',
    value: 'COMPLETE',
    color: 'success',
  },
  CANCEL: {
    text: '취소',
    value: 'CANCEL',
    color: 'error',
  },
} as const;

/**
 * [재고관리 > 반출 요청 관리] 반출 취소 가능한 상태 코드
 */
export const STOCK_RELEASE_CANCEL_ALLOW_CODES: string[] = [STOCK_RELEASE_REQUEST_STATUS.REQUEST.value];

/**
 * [재고관리 > 반출 요청 관리] 반출 요청 가능한 최대 상품 수량
 */
export const MAX_STOCK_RELEASE_REQUEST_PRODUCT_COUNT = 500;

/**
 * [재고관리 > 반출 요청 관리] 반출 요청 등록 시 패킹 방식 선택 가능한 반출 방식 코드
 */
export const STOCK_RELEASE_PACKING_METHOD_ALLOW_CODES = ['PICKUP', 'TRUCK'];

/**
 * [재고관리 > 반출 요청 관리] 반출 요청 등록 시 파렛트 전표 정보 입력 필요한 패킹 방식 코드
 */
export const STOCK_RELEASE_PALLET_INFO_REQUIRED_CODES = ['PALLET'];

/**
 * [재고관리] 툴팁 메시지
 */
export const STOCK_TOOLTIP_MESSAGE = {
  RELEASE_REQUEST_DATE: '반출 희망일과 실제 반출일은\n현장 운영 상황에 따라 달라질 수 있습니다.',
  RELEASE_METHOD: '반출된 재고를 어떤 방식으로\n수령할지 선택할 수 있습니다.',
};

/**
 * [재고관리] 반출 요청 관리 최대 검색 기간 (일 단위)
 */
export const STOCK_RELEASE_MAX_SEARCH_PERIOD_DAYS = 31;
